/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Panel, Button } from 'react-bootstrap';
import deviceActions from 'loraactions/device';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ShowIf from 'loracoms/ShowIf';
import DeleteModal from 'loracoms/DeleteModal';
import {
  normalizeDevEUI,
} from 'lorautils/IdUtils';
import callAPI from '@/api/callAPI';
import AddModal from '../AddModal';
import styles from './styles.scss';

const propTypes = {
  intl: PropTypes.object.isRequired,
  getDefLinks: PropTypes.func.isRequired,
  linkState: PropTypes.object.isRequired,
  deviceId: PropTypes.string.isRequired,
};

class DefLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      linkState: props.linkState,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.topoview');
  }

  componentWillMount() {
    const { deviceId, getDefLinks } = this.props;
    getDefLinks(deviceId);
  }

  componentWillReceiveProps(nextProps) {
    const { linkState } = nextProps;
    if (linkState !== this.props.linkState) {
      this.setState({ linkState });
      if (linkState.data && linkState.data.gateway) {
        this.loadGatewayDetail(linkState.data.gateway);
      }
    }
  }

  loadGatewayDetail(gateway) {
    callAPI({ endpoint: `lora/gateways/${gateway}` })
      .then((res) => {
        this.setState({ gatewayName: res.name });
      }).catch(() => {});
  }

  handleOnsuccess(gateway) {
    const { deviceId, getDefLinks } = this.props;
    const { linkState: { data } } = this.state;
    if (data.gateway !== gateway) {
      getDefLinks(deviceId);
    }
    this.setState({ showModal: false });
  }

  handleOnDelete() {
    callAPI({
      endpoint: `/lora/nodes/${this.props.deviceId}/deflink`,
      method: 'DELETE',
    }).then(() => {
      const { deviceId, getDefLinks } = this.props;
      getDefLinks(deviceId);
      this.setState({ showDeleteModal: false });
    }).catch(() => {});
  }

  render() {
    const {
      linkState: { data },
      showModal = false,
      showDeleteModal = false,
      gatewayName = '',
    } = this.state;
    if (!data) {
      return null;
    }
    const header = data.gateway.length === 0 ?
      (<div>
        {this.intlMsg.msg('deflink.downlink')}
        <Button
          className={`btn-aisz-success ${styles.marginLm}`}
          onClick={() => this.setState({ showModal: true })}
        >
          {this.intlMsg.msg('deflink.add')}
          <span className="glyphicon glyphicon-plus" />
        </Button>
      </div>) :
      this.intlMsg.msg('deflink.downlink');
    return (
      <Panel bsStyle="aisz-white" header={header}>
        <ShowIf if={data.gateway.length > 0}>
          <div>
            <div className={styles.gatewayName}>
              {gatewayName}
            </div>
            <div>
              <Link
                className={styles.gateway}
                to={`/gateway/detail/${data.gateway}`}
              >
                {normalizeDevEUI(data.gateway)}
              </Link>
              <Link
                className={styles.edit}
                onClick={() => this.setState({ showModal: true })}
              >
                <span className="glyphicon glyphicon-pencil" />
              </Link>
              <Link
                className={styles.delete}
                onClick={() => this.setState({ showDeleteModal: true })}
              >
                <span className="halflings halflings-trash" />
              </Link>
            </div>
          </div>
        </ShowIf>
        <AddModal
          showModal={showModal}
          deviceId={this.props.deviceId}
          onHide={() => this.setState({ showModal: false })}
          onSuccess={g => this.handleOnsuccess(g)}
          gateway={data.gateway}
        />
        <DeleteModal
          showModal={showDeleteModal}
          headerText={this.intlMsg.msg('deflink.delete')}
          text={`${this.intlMsg.msg('deflink.deletetip')}(${data.gateway})?`}
          onConfirm={() => this.handleOnDelete()}
          onCancel={() => this.setState({ showDeleteModal: false })}
        />
      </Panel>
    );
  }
}

DefLink.propTypes = propTypes;

const mapStateToProps = state => ({
  linkState: state.device.getDefLinks || {},
});

const mapDispatchToProps = {
  getDefLinks: deviceActions.getDefLinks,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DefLink));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/TopoView/coms/DefLink/index.jsx